const selectItems = [
  { id: 0, value: '', label: '' },
  { id: 1, value: 'highLow', label: 'Price high - low' },
  { id: 2, value: 'lowHigh', label: 'Price low - high' },
  { id: 3, value: 'alphabetically', label: 'Alphabetically' },
];

export default selectItems;
